import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import BredcomSlider from '../Bredcom/MainSlider'
import NewMain from '../headerone/newMain'



function Hostel() { 
  return (
    <>
    
      <NewMain />
        <Bredcom title="Home" subtitle="Hostel" />
        <section className="about-area about-p pt-60 pb-60 p-relative fix">
          <div className="container">
            <h2 class="text-center"> Gym and Sports  </h2>
            <br/>
          </div>
          <div className="container">
            <div className="row sports" >
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-1.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-2.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-3.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-4.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-5.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-6.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-7.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-8.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-9.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-10.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-11.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-12.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-13.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-14.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-15.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-16.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-17.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-18.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-19.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-20.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-21.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-22.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-23.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-24.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-25.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-26.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-27.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-28.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-29.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-30.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-31.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-32.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-33.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-34.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-35.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-36.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-37.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-38.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-39.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-40.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-41.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-42.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="one_team_member01">
                  <img src="assets/img/sport-43.jpg"  alt="img" className="vc-img" />
                </div>
              </div>
            </div>
          </div>
        </section>
    </>
  )
}

export default Hostel